// Created on 2024-01-24
// Created by Rodrigo Lyra
//
// Copyright (c) 2024 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * Update [[CollisionManager]] in OccViewer.
 * @internal
*/
OccViewer.onInit((theModule) => {
    let aCollisionManager = theModule.collisionManager;
    aCollisionManager.checkCollisionAsync = function (theMeshIdList1, theMeshIdList2) {
        return new Promise((theResolve, theReject) => {
            const aCallable = {
                _myObj: undefined,
                resolve: function () {
                    theResolve(true);
                    this._myObj.delete();
                },
                reject: function (theErr) {
                    if (theErr.length == 0) {
                        theResolve(false);
                    }
                    else {
                        theReject(new Error(theErr));
                    }
                    this._myObj.delete();
                }
            };
            const aWasmPromise = theModule.IPromise.implement(aCallable);
            aCallable._myObj = aWasmPromise;
            //@ts-ignore
            this._cppCheckCollisionAsync(theMeshIdList1, theMeshIdList2, aWasmPromise);
        });
    };
});
